import 'jquery';

export default {
  init() {
    // JavaScript to be fired on the about us page
    console.log('community search page')
    const BASEURL = 'https://shurm.test/'

    const preLoadedContent = `${ BASEURL }/wp-json/wp/v2/area`;


    $( document ).on( 'facetwp-loaded', function() {

      console.log(preLoadedContent)

      const mainContentTitle = document.getElementById('main_content__title');
      let mainContentText = document.querySelector('.main-content__content');
      const content = document.querySelector('.main-content__content');

      (function ($) {

        // const filterLocationCheckbox = document.querySelector('.facetwp-facet-comm_location');
        //
        // const filterLocationValue = $(this).data('.facetwp-facet-comm_location .checked');

        const filterSelectedValue = $('.facetwp-facet-location  .checked').data('value');

        const loadedContent = `${ BASEURL }/wp-json/wp/v2/area?slug=${ filterSelectedValue }`;

        function loadMainContent() {
          if($('.facetwp-facet-location ').has('.checked')) {
            $.ajax({
              url: loadedContent,
              dataType: 'json',
              success(res) {
                // $('.container-content').html(res);
                $.each(res, function(i, tx){
                  // $('.container-content').html(res);
                  console.log(tx)
                  if(filterSelectedValue === '') {
                    if(tx.parent == 0) {
                      mainContentTitle.innerText = tx.name;
                      mainContentText.innerHTML =  tx.description;
                    }
                  }else {
                    mainContentTitle.innerText = tx.name;
                    mainContentText.innerHTML =  tx.description;
                  }
                })
              },
            })
          }
        }
        loadMainContent()

        function filterCommunityLocation() {
          const filterValue = $(this).attr('data-value');

          const dataMarketing = `${ BASEURL }/wp-json/wp/v2/area?slug=${ filterValue }`

          $.ajax({
            url: dataMarketing,
            dataType: 'json',
            success(res) {
              // $('.container-content').html(res);
              $.each(res, function(i, tx){
                // $('.container-content').html(res);

                if(filterValue === '') {
                  mainContentTitle.innerText = 'Vermont Living';
                  mainContentText.innerHTML =  defaultContent;
                } else {
                  mainContentTitle.textContent = tx.name;
                  mainContentText.innerHTML =  tx.description;
                }
              })
            }
          })
        }
        $( document ).on( 'click', '.facetwp-facet-location .checked', function() {
          filterCommunityLocation();
        } );

      }( jQuery ));
    });



    (function($) {

      let btnSwitchMap = document.querySelector('.btn__show-map');
      btnSwitchMap.addEventListener('click', function (e){
        e.preventDefault()


        const mapArea = document.querySelector('.map-area');
        const cardView = document.querySelector('.card-view');
        const mapTitle = document.querySelector('.map_title');
        const mapIcon = document.querySelector('.map_icon');

        // $( ".map-area" ).toggle('slow');
        $(".map-area, .card-view").slideToggle();

        if(mapTitle.innerHTML == 'View Map') {
          mapTitle.innerHTML = 'Grid View'
        }else {
          mapTitle.innerHTML = 'View Map'
        }

        if(mapIcon.innerHTML == '<i class="fa-solid fa-location-dot"></i>'){
          mapIcon.innerHTML = '<i class="fas fa-border-all"></i>'
        }else {
          mapIcon.innerHTML = '<i class="fa-solid fa-location-dot"></i>'
        }

      })

      let btnSwitchMap1 = document.querySelector('.btn__show-map1');
      btnSwitchMap1.addEventListener('click', function (e){
        e.preventDefault()


        const mapArea = document.querySelector('.map-area');
        const cardView = document.querySelector('.card-view');
        const mapTitle = document.querySelector('.btn_show-map_label');
        const mapIcon = document.querySelector('.btn_show-map_icon');



        // $( ".map-area" ).toggle('slow');
        $(".map-area, .card-view").slideToggle();

        if(mapTitle.innerHTML == 'View Map') {
          mapTitle.innerHTML = 'Grid View'
        }else {
          mapTitle.innerHTML = 'View Map'
        }

        if(mapIcon.innerHTML == '<i class="fa-solid fa-location-dot"></i>'){
          mapIcon.innerHTML = '<i class="fas fa-border-all"></i>'
        }else {
          mapIcon.innerHTML = '<i class="fa-solid fa-location-dot"></i>'
        }



      })

    })(jQuery);

    ( function( $ ) {
      /**
       * initMap
       *
       * Renders a Google Map onto the selected jQuery element
       *
       * @date 22/10/19
       * @param $el
       * @since 	5.8.6
       * @param jQuery $el The jQuery element.
       * @return 	object The map instance.
       */
      function initMap( $el ) {
        // Find marker elements within map.
        const $markers = $el.find( '.marker' );

        // Create gerenic map.
        const mapArgs = {
          zoom: $el.data( 'zoom' ) || 16,
          mapTypeId: google.maps.MapTypeId.ROADMAP,

        };
        const map = new google.maps.Map( $el[ 0 ], mapArgs );

        // Add markers.
        map.markers = [];
        $markers.each( function() {
          initMarker( $( this ), map );
        } );

        // Center map based on markers.
        centerMap( map );

        // Return map instance.
        return map;
      }

      /**
       * initMarker
       *
       * Creates a marker for the given jQuery element and map.
       *
       * @date 22/10/19
       * @since 	5.8.6
       * @param $marker
       * @param map
       * @param jQuery $el The jQuery element.
       * @param object The map instance.
       * @return 	object The marker instance.
       */
      function initMarker( $marker, map ) {
        // Get position from marker.
        const lat = $marker.data( 'lat' );
        const lng = $marker.data( 'lng' );
        const latLng = {
          lat: parseFloat( lat ),
          lng: parseFloat( lng ),
        };

        // Create marker instance.
        const marker = new google.maps.Marker( {
          position: latLng,
          map,
          // icon: 'https://newhomeinc1dev.wpengine.com/wp-content/uploads/2022/01/google-map-marker.png',
        } );

        // Append to reference for later use.
        map.markers.push( marker );

        // If marker contains HTML, add it to an infoWindow.
        if ( $marker.html() ) {
          // Create info window.
          const infowindow = new google.maps.InfoWindow( {
            content: $marker.html(),
          } );

          // Show info window when marker is clicked.
          google.maps.event.addListener( marker, 'click', function() {
            infowindow.open( map, marker );
          } );
        }
      }

      /**
       * centerMap
       *
       * Centers the map showing all markers in view.
       *
       * @date 22/10/19
       * @param map
       * @since 	5.8.6
       * @param object The map instance.
       * @return 	void
       */
      function centerMap( map ) {
        // Create map boundaries from all map markers.
        const bounds = new google.maps.LatLngBounds();
        map.markers.forEach( function( marker ) {
          bounds.extend( {
            lat: marker.position.lat(),
            lng: marker.position.lng(),
          } );
        } );

        // Case: Single marker.
        if ( map.markers.length == 1 ) {
          map.setCenter( bounds.getCenter() );

          // Case: Multiple markers.
        } else {
          map.fitBounds( bounds );
        }
      }

      // Render maps on page load.
      // $( document ).ready( function() {
      //   $( '.location-component-map .acf-map' ).each( function() {
      //     const map = initMap( $( this ) );
      //   } );
      // } );

      $( document ).on( 'facetwp-loaded', function() {
        $( '#map' ).each( function() {
          const map = initMap( $( this ) );
        } );
      } );
    }( jQuery ) );

  },
};
